import { StyleSheet } from "react-native";

import { Flex, Box, Tag } from "../../../../../../mads";
import type { TagModel } from "../../../../viewjobOneGraphModel";

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginBottom: 16,
  },
  tagContainer: { marginRight: 4 },
});

export function TagContainer({ tags }: { tags: TagModel[] }) {
  return (
    <Flex sx={styles.container}>
      {tags.map((tag, index) => (
        <Box key={index} sx={styles.tagContainer}>
          <Tag>{tag.text}</Tag>
        </Box>
      ))}
    </Flex>
  );
}
